import type { ComponentChildren } from "preact";
import { useEffect } from "preact/hooks";

type SheetProps = {
  open: boolean;
  onClose: () => void;
  children?: ComponentChildren;
  labelledBy?: string;
};

/** Bottom sheet on mobile, centered modal on desktop. Escape + backdrop close it. */
export function Sheet({ open, onClose, children, labelledBy }: SheetProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <>
      <div class="sheet-backdrop" onClick={onClose} />
      <div class="sheet" role="dialog" aria-modal="true" aria-labelledby={labelledBy}>
        {children}
      </div>
    </>
  );
}
